module.exports = __webpack_public_path__ + "static/media/top-logo-902-ja-2.36e1d929.png";